<!-- =========================================================================================
    File Name: ApexCharts.vue
    Description: Apex Charts Demo
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="extra-component-chartist-demo">
    <p class="mb-4">A Vue.js component for ApexCharts. Read full documnetation
      <a href="https://apexcharts.com/docs/installation/" rel="nofollow" target="_blank">here</a></p>

    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card code-toggler title="Line Chart">
          <vue-apex-charts :options="apexChatData.lineChartSimple.chartOptions" :series="apexChatData.lineChartSimple.series" height="350" type="line"></vue-apex-charts>
          <template slot="codeContainer">
            {{ apexChatData.lineChartSimpleCode }}
          </template>
        </vx-card>
      </div>

      <!-- LINE AREA CHART -->
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card code-toggler title="Line Area Chart">
          <vue-apex-charts :options="apexChatData.lineAreaChartSpline.chartOptions" :series="apexChatData.lineAreaChartSpline.series" height="350" type="area"></vue-apex-charts>
          <template slot="codeContainer">
            {{ apexChatData.lineAreaChartSplineCode }}
          </template>
        </vx-card>
      </div>

      <!-- COLUMN CHART -->
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card code-toggler title="Column Chart">
          <vue-apex-charts :options="apexChatData.columnChart.chartOptions" :series="apexChatData.columnChart.series" height="350" type="bar"></vue-apex-charts>
          <template slot="codeContainer">
            {{ apexChatData.columnChartCode }}
          </template>
        </vx-card>
      </div>

      <!-- Bar CHART -->
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card code-toggler title="Bar Chart">
          <vue-apex-charts :options="apexChatData.barChart.chartOptions" :series="apexChatData.barChart.series" height="350" type="bar"></vue-apex-charts>
          <template slot="codeContainer">
            {{ apexChatData.barChartCode }}
          </template>
        </vx-card>
      </div>

      <!-- MIXED CHART -->
      <div class="vx-col w-full mb-base">
        <vx-card code-toggler title="Mixed Chart">
          <vue-apex-charts :options="apexChatData.mixedChart.chartOptions" :series="apexChatData.mixedChart.series" height="350" type="line"></vue-apex-charts>
          <template slot="codeContainer">
            {{ apexChatData.mixedChartCode }}
          </template>
        </vx-card>
      </div>

      <!-- CANDLESTICK CHART -->
      <div class="vx-col w-full mb-base">
        <vx-card code-toggler title="Candlestick Chart">
          <vue-apex-charts :options="apexChatData.candlestickChart.chartOptions" :series="apexChatData.candlestickChart.series" height="350" type="candlestick"></vue-apex-charts>
          <template slot="codeContainer">
            {{ apexChatData.candlestickChartCode }}
          </template>
        </vx-card>
      </div>

      <!-- BUBBLE CHART -->
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card code-toggler title="3D Bubble Chart">
          <vue-apex-charts :options="apexChatData.bubbleChart.chartOptions" :series="apexChatData.bubbleChart.series" height="350" type="bubble"></vue-apex-charts>
          <template slot="codeContainer">
            {{ apexChatData.bubbleChartCode }}
          </template>
        </vx-card>
      </div>

      <!-- SCATTER CHART -->
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card code-toggler title="Scatter Chart">
          <vue-apex-charts :options="apexChatData.scatterChart.chartOptions" :series="apexChatData.scatterChart.series" height="350" type="scatter"></vue-apex-charts>
          <template slot="codeContainer">
            {{ apexChatData.scatterChartCode }}
          </template>
        </vx-card>
      </div>

      <!-- HEAT MAP CHART -->
      <div class="vx-col w-full mb-base">
        <vx-card code-toggler title="Heat Map Chart">
          <vue-apex-charts :options="apexChatData.heatMapChart.chartOptions" :series="apexChatData.heatMapChart.series" height="350" type="heatmap"></vue-apex-charts>
          <template slot="codeContainer">
            {{ apexChatData.heatMapChartCode }}
          </template>
        </vx-card>
      </div>

      <!-- PIE CHART -->
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card code-toggler title="Pie Chart">
          <vue-apex-charts :options="apexChatData.pieChart.chartOptions" :series="apexChatData.pieChart.series" height="350" type="pie"></vue-apex-charts>
          <template slot="codeContainer">
            {{ apexChatData.pieChartCode }}
          </template>
        </vx-card>
      </div>

      <!-- DONUT CHART -->
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card code-toggler title="Donut Chart">
          <vue-apex-charts :options="apexChatData.donutChart.chartOptions" :series="apexChatData.donutChart.series" height="350" type="donut"></vue-apex-charts>
          <template slot="codeContainer">
            {{ apexChatData.donutChartCode }}
          </template>
        </vx-card>
      </div>

      <!-- RADIAL BAR CHART -->
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card code-toggler title="Radial Bar Chart">
          <vue-apex-charts :options="apexChatData.radialBarChart.chartOptions" :series="apexChatData.radialBarChart.series" height="350" type="radialBar"></vue-apex-charts>
          <template slot="codeContainer">
            {{ apexChatData.radialBarChartCode }}
          </template>
        </vx-card>
      </div>

      <!-- RADAR CHART -->
      <div class="vx-col md:w-1/2 w-full">
        <vx-card code-toggler title="Radar Chart">
          <vue-apex-charts :options="apexChatData.radarChart.chartOptions" :series="apexChatData.radarChart.series" height="350" type="radar"></vue-apex-charts>
          <template slot="codeContainer">
            {{ apexChatData.radarChartCode }}
          </template>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  import apexChatData from './apexChartData.js'

  export default {
    data ()
    {
      return {
        apexChatData
      }
    },
    components: {
      VueApexCharts
    }
  }
</script>
